import { Typography, Box } from "@mui/material";
import ModelTestingForm from './ModelTesting-comp';

const ModelTesting = () => {
  return <ModelTestingForm />;
};

export default ModelTesting
